import React from 'react';
import styled from 'styled-components';

import theme from '../styles/theme';

export enum StyledTextVariantsType {
    DISPLAY = 'display',
    HEADING_1 = 'heading1',
    HEADING_2 = 'heading2',
    HEADING_3 = 'heading3',
    HEADING_4 = 'heading4',
    HEADING_5 = 'heading5',
    HEADING_6 = 'heading6',
    CAPS_1_BOLD = 'caps1Bold',
    CAPS_1_REGULAR = 'caps1Regular',
    CAPS_2_BOLD = 'caps2Bold',
    CAPS_2_REGULAR = 'caps3Regular',
    CAPS_3_BOLD = 'caps3Bold',
    CAPS_3_REGULAR = 'caps3Regular',
    PARAGRAPH_1 = 'paragraph1',
    PARAGRAPH_2 = 'paragraph2',
    PARAGRAPH_3 = 'paragraph3',
    PARAGRAPH_4 = 'paragraph4',
    BUTTON_TEXT = 'buttonText',
    LABEL_TEXT = 'labelText',
    CAPS_LINK_1 = 'capsLink1',
    LINK_1 = 'link1',
    LINK_2 = 'link2',
    LINK_3 = 'link3',
    LINK_4 = 'link4',
    TITLE = 'title',
}

export enum StyledTextVariantsTypeV2 {
    HEADING_1 = 'heading1',
    HEADING_2 = 'heading2',
    HEADING_3 = 'heading3',
    HEADING_4 = 'heading4',
    HEADING_5 = 'heading5',
    HEADING_6 = 'heading6',

    HEADING_1_BOLD = 'heading1Bold',
    HEADING_2_BOLD = 'heading2Bold',
    HEADING_3_BOLD = 'heading3Bold',
    HEADING_4_BOLD = 'heading4Bold',
    HEADING_5_BOLD = 'heading5Bold',
    HEADING_6_BOLD = 'heading6Bold',

    TABLE_HEADER = 'tableHeader',

    PARAGRAPH_1 = 'paragraph1',
    PARAGRAPH_2 = 'paragraph2',
    PARAGRAPH_3 = 'paragraph3',
    PARAGRAPH_4 = 'paragraph4',
    PARAGRAPH_5 = 'paragraph5',

    PARAGRAPH_1_BOLD = 'paragraph1Bold',
    PARAGRAPH_2_BOLD = 'paragraph2Bold',
    PARAGRAPH_3_BOLD = 'paragraph3Bold',
    PARAGRAPH_4_BOLD = 'paragraph4Bold',
    PARAGRAPH_5_BOLD = 'paragraph5Bold',

    PARAGRAPH_UPPERCASE1 = 'paragraphUppercase1',
    PARAGRAPH_UPPERCASE2 = 'paragraphUppercase2',

    BUTTON_L = 'buttonLarge',
    BUTTON = 'buttonDefault',
    BUTTON_S = 'buttonSmall',

    LINK_1 = 'link1',
    LINK_2 = 'link2',
    LINK_3 = 'link3',
    LINK_4 = 'link4',

    NAV = 'nav',
    TAB = 'tab',

    NAV_BOLD = 'navBold',
    TAB_BOLD = 'tabBold',

    NAV_UPPERCASE1 = 'navUppercase1',
    TAB_UPPERCASE1 = 'tabUppercase1',
    NAV_UPPERCASE2 = 'navUppercase2',
    TAB_UPPERCASE2 = 'tabUppercase2',

    CELL_MEDIUM = 'cellMedium',
    CELL_BOLD = 'cellBold',
    CELL_SEMIBOLD = 'cellSemibold',

    CELL_HEADER = 'cellHeader',

    INPUT_TITLE = 'inputTitle',
    INPUT_PLACHOLDER = 'inputPlaceholder',
    INPUT_SELECTED = 'inputSelected',
}

interface IProps {
    text?: string;
    variant: StyledTextVariantsTypeV2;
    colorVariant?: string;
    textAlign?: 'center' | 'justify' | 'left' | 'right' | 'initial';
    styles?: {};
    width?: string;
    margin?: string;
    zIndex?: number;
    onClick?: (e: any) => void;
    classNames?: string;
    whiteSpace?: string;
    cursor?: string;
}

const styles = {
    heading1: { fontFamily: theme.typography.semiBold, fontSize: 42, letterSpacing: -0.24 },
    heading2: { fontFamily: theme.typography.semiBold, fontSize: 36, letterSpacing: -0.11 },
    heading3: { fontFamily: theme.typography.semiBold, fontSize: 32, letterSpacing: -0.16 },
    heading4: { fontFamily: theme.typography.semiBold, fontSize: 28, letterSpacing: -0.16 },
    heading5: { fontFamily: theme.typography.semiBold, fontSize: 22, letterSpacing: -0.16 },
    heading6: { fontFamily: theme.typography.semiBold, fontSize: 16, letterSpacing: -0.08 },

    heading1Bold: { fontFamily: theme.typography.bold, fontSize: 42, letterSpacing: -0.32 },
    heading2Bold: { fontFamily: theme.typography.bold, fontSize: 36, letterSpacing: -0.16 },
    heading3Bold: { fontFamily: theme.typography.bold, fontSize: 32, letterSpacing: -0.24 },
    heading4Bold: { fontFamily: theme.typography.bold, fontSize: 28, letterSpacing: -0.16 },
    heading5Bold: { fontFamily: theme.typography.bold, fontSize: 22, letterSpacing: -0.18 },
    heading6Bold: { fontFamily: theme.typography.bold, fontSize: 16, letterSpacing: -0.06 },

    tableHeader: {
        fontFamily: theme.typography.bold,
        fontSize: 10,
        letterSpacing: 1.0,
        textTransform: 'uppercase',
        color: theme.colors.v2.light.grayscale[50],
    },

    paragraph1: { fontFamily: theme.typography.regular, fontSize: 18, letterSpacing: -0.12 },
    paragraph2: { fontFamily: theme.typography.regular, fontSize: 16, letterSpacing: -0.08 },
    paragraph3: { fontFamily: theme.typography.regular, fontSize: 14, letterSpacing: -0.08 },
    paragraph4: { fontFamily: theme.typography.regular, fontSize: 12, letterSpacing: -0.08 },
    paragraph5: { fontFamily: theme.typography.regular, fontSize: 10, letterSpacing: -0.08 },

    paragraph1Bold: { fontFamily: theme.typography.bold, fontSize: 18, letterSpacing: -0.12 },
    paragraph2Bold: { fontFamily: theme.typography.bold, fontSize: 16, letterSpacing: -0.08 },
    paragraph3Bold: { fontFamily: theme.typography.bold, fontSize: 14, letterSpacing: -0.08 },
    paragraph4Bold: { fontFamily: theme.typography.bold, fontSize: 12, letterSpacing: -0.08 },
    paragraph5Bold: { fontFamily: theme.typography.bold, fontSize: 10, letterSpacing: -0.08 },

    paragraphUppercase1: {
        fontFamily: theme.typography.bold,
        fontSize: 12,
        letterSpacing: 1.0,
        textTransform: 'uppercase',
    },
    paragraphUppercase2: {
        fontFamily: theme.typography.bold,
        fontSize: 10,
        letterSpacing: 1.0,
        textTransform: 'uppercase',
    },

    buttonLarge: { fontFamily: theme.typography.semiBold, fontSize: 16, letterSpacing: -0.08 },
    buttonDefault: { fontFamily: theme.typography.semiBold, fontSize: 14, letterSpacing: -0.08 },
    buttonSmall: { fontFamily: theme.typography.semiBold, fontSize: 12, letterSpacing: -0.08 },

    link1: {
        fontFamily: theme.typography.semiBold,
        fontSize: 18,
        letterSpacing: -0.16,
        color: theme.colors.v2.light.darkCyan.default,
        textDecoration: 'underline',
    },
    link2: {
        fontFamily: theme.typography.semiBold,
        fontSize: 16,
        letterSpacing: -0.12,
        color: theme.colors.v2.light.darkCyan.default,
        textDecoration: 'underline',
    },
    link3: {
        fontFamily: theme.typography.semiBold,
        fontSize: 14,
        letterSpacing: -0.08,
        color: theme.colors.v2.light.darkCyan.default,
        textDecoration: 'underline',
    },
    link4: {
        fontFamily: theme.typography.semiBold,
        fontSize: 12,
        letterSpacing: -0.08,
        color: theme.colors.v2.light.darkCyan.default,
        textDecoration: 'underline',
    },

    nav: { fontFamily: theme.typography.semiBold, fontSize: 15, letterSpacing: -0.08 },
    tab: { fontFamily: theme.typography.semiBold, fontSize: 15, letterSpacing: -0.08 },

    navBold: { fontFamily: theme.typography.bold, fontSize: 15, letterSpacing: -0.08 },
    tabBold: { fontFamily: theme.typography.bold, fontSize: 15, letterSpacing: -0.08 },

    navUppercase1: { fontFamily: theme.typography.bold, fontSize: 15, letterSpacing: 0.24, textTransform: 'uppercase' },
    tabUppercase1: { fontFamily: theme.typography.bold, fontSize: 15, letterSpacing: 0.24, textTransform: 'uppercase' },
    navUppercase2: { fontFamily: theme.typography.bold, fontSize: 12, letterSpacing: 0.36, textTransform: 'uppercase' },
    tabUppercase2: { fontFamily: theme.typography.bold, fontSize: 12, letterSpacing: 0.36, textTransform: 'uppercase' },

    cellMedium: { fontFamily: theme.typography.medium, fontSize: 15, letterSpacing: -0.16 },
    cellBold: { fontFamily: theme.typography.bold, fontSize: 15, letterSpacing: -0.16 },
    cellSemibold: { fontFamily: theme.typography.semiBold, fontSize: 15, letterSpacing: -0.16 },

    cellHeader: {
        fontFamily: theme.typography.semiBold,
        fontSize: 15,
        letterSpacing: -0.16,
        textTransform: 'uppercase',
    },

    inputTitle: {
        fontFamily: theme.typography.bold,
        fontSize: 9,
        letterSpacing: 1.0,
        textTransform: 'uppercase',
        color: theme.colors.light.grayscale[200],
    },
    inputPlaceholder: { fontFamily: theme.typography.regular, fontSize: 14, letterSpacing: 0, fontStyle: 'italic' },
    inputSelected: { fontFamily: theme.typography.bold, fontSize: 14, letterSpacing: 0 },
};

const StyledTextWrapper = styled.div<IProps>`
    box-sizing: border-box;
    text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')};
    width: ${({ width }) => (width ? width : 'auto')};
    margin: ${({ margin }) => (margin ? margin : 0)};
    white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : 'unset')};
    z-index: ${(props) => (props.zIndex ? props.zIndex : 'initial')};
    cursor: ${({ variant, cursor }) =>
        variant.toLowerCase().indexOf('link') > -1 ? 'pointer' : cursor ? cursor : 'inherit'};
    color: ${({ variant, colorVariant }) =>
        variant.toLowerCase().indexOf('link') > -1 ? theme.colors.light.blue.baseLight : colorVariant};
`;

const StyledText = (props: IProps) => {
    return (
        <StyledTextWrapper
            {...props}
            className={`${props.classNames || ''}`}
            onClick={props.onClick}
            style={{ ...styles[props.variant], ...props.styles } as any}
        >
            {props.text}
        </StyledTextWrapper>
    );
};

StyledText.defaultProps = {
    text: '',
    variant: StyledTextVariantsTypeV2.HEADING_6,
    colorVariant: theme.constantStyles.colorStyles.black,
    textAlign: 'left',
    opacity: 1,
    width: 'auto',
    styles: {},
} as Partial<IProps>;

export default StyledText;
